import { z } from 'zod'

// ── Nudge severity ─────────────────────────────────────────────────────────────

export const nudgeSeveritySchema = z.enum(['info', 'gentle', 'concerned'])
export type NudgeSeverity = z.infer<typeof nudgeSeveritySchema>

// ── Nudge row ──────────────────────────────────────────────────────────────────

export const nudgeRowSchema = z.object({
  id: z.guid(),
  // The api also returns employee_id but the web doesn't render it; allow
  // it through for forward-compatibility.
  employee_id: z.guid().optional(),
  nudge_type: z.string(),
  severity: nudgeSeveritySchema,
  // Evidence is a JSONB dict on the server (e.g. {days_since_last_leave: 73,
  // annual_remaining: 7, ...}) — never a string. Zod was previously
  // rejecting the api payload, which silently broke the WellbeingPanel
  // render. Accept any shape; the panel renders only fields it knows.
  evidence: z.record(z.string(), z.unknown()),
  suggestion_text: z.string(),
  seen_at: z.string().nullable(),
  dismissed_at: z.string().nullable(),
  acted_on_leave_id: z.guid().nullable(),
  created_at: z.string(),
})

export type NudgeRow = z.infer<typeof nudgeRowSchema>

// ── List response ──────────────────────────────────────────────────────────────

export const nudgeListResponseSchema = z.object({
  nudges: z.array(nudgeRowSchema),
})

export type NudgeListResponse = z.infer<typeof nudgeListResponseSchema>

// ── PATCH body ─────────────────────────────────────────────────────────────────

export const nudgePatchBodySchema = z.object({
  seen_at: z.string().optional(),
  dismissed_at: z.string().optional(),
  acted_on_leave_id: z.guid().optional(),
})

export type NudgePatchBody = z.infer<typeof nudgePatchBodySchema>
